import { ConsumptionTypeEnum, ConsumptioOrRevenueTypeEnum } from "../SuperEnum";
import Tools from "../Tools";
import ad_account from "../vo/dbvo/ad_account";
import ad_consumption_record from "../vo/dbvo/ad_consumption_record";
import ad_exposure_record from "../vo/dbvo/ad_exposure_record";
import ad_recharge_record from "../vo/dbvo/ad_recharge_record";

/**
 * 日志相关API
 */
export default class RecordApi {
    /**
     * 获取充值记录
     * @param page 
     * @param pageSize 
     */
    public async GetRechargeRecordAsync(page: number, pageSize: number) {
        return await Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_recharge_record[]
        }>("Record/GetRechargeRecord", {
            page,
            pageSize
        }, "GET");
    }

    /**
     * 获取我的推广广告曝光记录
     * @param page 
     * @param pageSize 
     * @returns 
     */
    public async GetMyAdExposureRecordAsync(page: number, pageSize: number) {
        return await Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_exposure_record[]
        }>("Record/GetMyAdExposureRecord", {
            page,
            pageSize
        }, "GET");
    }

    /**
     * 获取我的收益记录
     * @param page 
     * @param pageSize 
     * @returns 
     */
    public async GetMyRevenueRecordAsync(page: number, pageSize: number) {
        return await Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: (ad_consumption_record & {
                user?: ad_account,
                sourceUser?: ad_account
            })[]
        }>("Record/GetMyRevenueRecord", {
            page,
            pageSize
        }, "GET");
    }


    /**
     * 获取我的消费或收益记录
     * (此处包含出售记录等)
     * @param page 
     * @param pageSize 
     * @returns 
     */
    public async GetMyConsumptioOrRevenueRecordAsync(page: number, pageSize: number, type: ConsumptioOrRevenueTypeEnum, consumptionType?: ConsumptionTypeEnum) {
        return await Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: (ad_consumption_record & {
                user?: ad_account,
                sourceUser?: ad_account
            })[]
        }>("Record/GetMyConsumptioOrRevenueRecord", {
            page,
            pageSize,
            type,
            consumptionType
        }, "GET");
    }
}